import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {NavbarComponent} from './navbar.component';

import {AdminWebAppRoutingModule} from '../../app-routing.module';

@NgModule({
  imports: [
    CommonModule,
    AdminWebAppRoutingModule,
  ],
  declarations: [
    NavbarComponent,
  ],
  providers: [
  ],
  exports: [
    NavbarComponent,
  ],
})
export class NavbarModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/navbar/navbar.module.ts